var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_87",
    "data-name": "Groupe 87",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.009,
    height: 34.009,
    viewBox: "0 0 34.009 34.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_168",
    "data-name": "Trac\\xE9 168",
    d: "M17,31.883A14.879,14.879,0,1,1,31.883,17,14.879,14.879,0,0,1,17,31.883Zm0,2.126A17,17,0,1,0,0,17,17,17,0,0,0,17,34.009Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    fill: "black",
    id: "Trac\\xE9_169",
    "data-name": "Trac\\xE9 169",
    d: "M11.239,9.581l-4.466.565-.16.748.878.163c.573.138.687.347.562.924L6.613,18.811c-.378,1.766.2,2.6,1.576,2.6a4.02,4.02,0,0,0,2.857-1.178l.172-.819A2.148,2.148,0,0,1,9.88,19.9c-.536,0-.731-.38-.593-1.05Zm.137-4.112A1.95,1.95,0,1,1,9.426,3.5,1.96,1.96,0,0,1,11.376,5.469Z",
    transform: "translate(8.066 4.55)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfos);
export default __webpack_public_path__ + "static/media/icon-infos.ddbc9026b2b5445b44dbaeb4e7a435d6.svg";
export { ForwardRef as ReactComponent };